export default function signUpLink(urlRef) {
  return "https://mailbrew.com/" + (urlRef ? `/?utm_source=${urlRef}` : "");
}
